import React from "react";
import Typography from "@common/components/Typography";

type ChartTitleProps = {
  title: string;
  unit: string;
  bgColor: string;
};

const ChartTitle = ({ title, unit, bgColor }: ChartTitleProps) => {
  const composedTitle = unit ? `${title}, ${unit}` : title;

  return (
    <Typography
      sx={{
        px: 2,
        py: 0.25,
        alignSelf: "start",
        borderTopLeftRadius: (theme) => theme.spacing(2),
        background: bgColor,
        textTransform: "uppercase",
      }}
    >
      {composedTitle}
    </Typography>
  );
};

export default ChartTitle;
